import React from 'react';
import { FaArrowRight, FaRegBuilding, FaBook } from 'react-icons/fa';
import { IoIosTimer, IoMdCall, IoMdMail, IoMdPin } from 'react-icons/io';
import { Link } from 'react-router-dom';
import logo from '../assets/cohesive-logo.png';

// Contact and Curriculum Data
const contacts = [
  {
    label: 'mail',
    email: 'info@cohesiveminds.com',
  },
];

const phoneNumbers = [
  {
    label: 'Contact',
    number: '+91-7835000266',
  },
];

const socialLinks = [
  {
    href: 'https://www.youtube.com/@cohesiveminds6974',
    src: require('../assets/icons/ytb.png'),
    alt: 'YouTube',
    className: 'h-5',
  },
  {
    href: 'https://www.instagram.com/cohesiveminds/',
    src: require('../assets/icons/instagram-logo.png'),
    alt: 'Instagram',
    className: 'h-[35px] w-[35px]',
  },
  {
    href: 'https://www.facebook.com/profile.php?id=61569671270471',
    src: require('../assets/icons/facebook.png'),
    alt: 'Facebook',
    className: 'h-6',
  },
  {
    href: 'https://www.linkedin.com/company/99324850',
    src: require('../assets/icons/linkedin.png'),
    alt: 'LinkedIn',
    className: 'h-6',
  },
];

const admissionLinks = [
  {
    name: 'Apply Now',
    href: 'https://thekhaitanschool.org/admission-enquiry/',
  },
];

const curriculumData = [
  {
    title: "ECCE",
    description: "Early Childhood Care & Education",
    href: "https://thekhaitanschool.org/pre-primary-2/",
  },
  {
    title: "Primary",
    description: "Primary School Curriculum",
    href: "https://thekhaitanschool.org/primary-school-curriculum/",
  },
  {
    title: "Middle & Senior",
    description: "Middle & Senior School Curriculum",
    href: "https://thekhaitanschool.org/curriculum/middle-senior-school-curriculum/",
  },
];

const technicalSupport = {
  company: 'TestKnock Technologies',
  email: 'info@testknock.com',
  phone: '+91-9560443520',
  address: `Office No. - 42, Durga Vihar, near Amrapali Sapphire, Sec-45, Noida-201301`,
};

const supportLinks = [
  {
    name: 'Terms & Conditions',
    href: '/Terms and Conditions for TestKnock.pdf',
  },
  {
    name: 'Cancellation/Refund Policy',
    href: '/Cancellation and Refund Policy for TestKnock.pdf',
  },
  {
    name: 'Privacy Policy',
    href: '/Privacy Policy for TestKnock.pdf',
  },
];

const Footer = () => {
  return (
    <footer className="bg-black text-white w-full py-10 flex justify-center items-center">
      <div className="w-full px-5">
        <div className="flex flex-col md:flex-row md:gap-8">
          {/* Left Section: Logo and Description */}
          <div className="md:w-1/3 flex flex-col">
            <Link to="/" className="flex items-center mt-4">
              <img src={logo} alt="Logo" className="h-16 w-16 pr-4 pb-2 mr-2" />
              <h2 className="text-white font-bold text-lg">COHESIVE MINDS</h2>
            </Link>
            <p className="mt-4 text-justify">
                "India's first platform to empower students, professionals and entrepreneurs with simplified, real-world skills to thrive in the 21st century"
            </p>
            <a
              target="_blank"
              href="https://www.cohesiveminds.com/"
              className="mt-4 inline-flex items-center bg-white text-black p-3 rounded-tl-2xl rounded-br-2xl"
              rel="noreferrer"
            >
              Learn More <FaArrowRight className="ml-2" />
            </a>
          </div>

          {/* Right Section */}
          <div className="md:w-2/3 grid md:grid-cols-2 gap-4">
            {/* Contact Us */}
            <div className="mx-auto">
              <p className="font-bold mb-4">Contact Us</p>
              <div className="flex items-center my-3">
                <IoMdCall className="text-lg mr-2" />
                <div>
                  {phoneNumbers.map((phone, index) => (
                    <div key={index} className="my-1">
                      <a href={`tel:${phone.number.replace(/[^+\d]/g, '')}`} className="hover:text-blue-500 text-white">
                        {phone.label}: {phone.number}
                      </a>
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex items-center my-3 hover:cursor-default">
                <IoIosTimer className="text-lg mr-2" />
                <span>Mon - Sat: 8.00 AM - 04.00 PM</span>
              </div>
              <div className="flex items-center my-3">
                <IoMdMail className="text-lg mr-2 mt-1" />
                <div>
                  {contacts.map((contact, index) => (
                    <div key={index} className="my-1">
                      <span>{contact.label}: <a href={`mailto:${contact.email}`} className="hover:text-blue-500 text-blue-300">{contact.email}</a></span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex gap-6 mt-4 items-center">
                {socialLinks.map((link, index) => (
                  <a key={index} href={link.href} target="_blank" rel="noreferrer">
                    <img src={link.src} alt={link.alt} className={link.className} />
                  </a>
                ))}
              </div>
            </div>

          {/* Technical Support */}
          <div className="mx-auto">
            <p className="font-bold mb-4">Any Technical Issues</p>
            <a
              href="https://www.testknock.com/"
              target="_blank"
              rel="noreferrer"
              className="flex items-start my-6 hover:text-blue-500 text-white"
            >
              <FaRegBuilding className="text-lg mr-2 mt-1" />
              {technicalSupport.company}
            </a>
            <div className="flex items-start my-6">
              <IoMdMail className="text-lg mr-2 mt-1" />
              <a
                href={`mailto:${technicalSupport.email}`}
                className="hover:text-blue-500 text-white"
              >
                {technicalSupport.email}
              </a>
            </div>
            <div className="flex items-start my-6">
              <IoMdCall className="text-lg mr-2 mt-1" />
              <a
                href={`tel:${technicalSupport.phone.replace(/[^+\d]/g, '')}`}
                className="hover:text-blue-500 text-white"
              >
                {technicalSupport.phone}
              </a>
            </div>
            <a
              href="https://goo.gl/maps/TestKnockLocation"
              target="_blank"
              rel="noreferrer"
              className="flex items-start my-6 hover:text-blue-500 text-white"
            >
              <IoMdPin className="text-lg mr-2 mt-1 h-[40px] w-[40px]" />
              <span>{technicalSupport.address}</span>
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="mt-6">
        <hr className="w-full text-white" />
        <div className="w-11/12 mx-auto flex flex-col md:flex-row justify-between items-center mt-3 text-sm">
          <div className="flex items-center mb-2 md:mb-0">
            &copy; 2025 <b className="ml-2">TestKnock Technologies Private Limited</b>
            <b className="ml-4">All rights reserved</b>
          </div>
          <div className="flex items-center gap-4">
            {supportLinks.map((link, index) => (
              <React.Fragment key={index}>
                <a
                  href={link.href}
                  target="_blank"
                  rel="noreferrer"
                  className="font-bold hover:text-blue-500"
                >
                  {link.name}
                </a>
                {index < supportLinks.length - 1 && <b>|</b>}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  </footer>
);
};

export default Footer;

